import axios from 'axios';
import { collection, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';

const API_URL = process.env.REACT_APP_API_URL || 'https://asia-southeast1-linxlab-website.cloudfunctions.net/openhouseApi';

// ดึงข้อมูลผู้ใช้จาก Firestore
export const getUserData = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      return { success: true, data: userSnap.data() };
    } else {
      return { success: false, message: 'ไม่พบข้อมูลผู้ใช้' };
    }
  } catch (error) {
    console.error('Error fetching user data:', error);
    return { success: false, message: 'เกิดข้อผิดพลาดในการดึงข้อมูล' };
  }
};

// เช็คอินผู้ใช้
export const checkInUser = async (userId) => {
  try {
    const response = await axios.post(`${API_URL}/check-in/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error checking in user:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'เกิดข้อผิดพลาดในการเช็คอิน'
    };
  }
};

// สร้าง Google Wallet Pass
export const generateGoogleWalletPass = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/wallet/google/${userId}`, {
      responseType: 'blob'
    });
    return {
      success: true,
      data: URL.createObjectURL(response.data),
      filename: 'LinxOpenHouse_GoogleWallet.pkpass'
    };
  } catch (error) {
    console.error('Error generating Google Wallet pass:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'เกิดข้อผิดพลาดในการสร้าง Google Wallet Pass'
    };
  }
};

// สร้าง Apple Wallet Pass
export const generateAppleWalletPass = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/wallet/apple/${userId}`, {
      responseType: 'blob'
    });
    return {
      success: true,
      data: URL.createObjectURL(response.data),
      filename: 'LinxOpenHouse_AppleWallet.pkpass'
    };
  } catch (error) {
    console.error('Error generating Apple Wallet pass:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'เกิดข้อผิดพลาดในการสร้าง Apple Wallet Pass'
    };
  }
};
